export function generateUpiUrl({ upiId, name, amount, currency, note } = {}) {
  if (!upiId) return "";

  const payeeName = name || "Merchant";
  let url = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(payeeName)}`;

  if (amount !== undefined && amount !== null && amount !== "") {
    url += `&am=${amount}`;
  }

  url += `&cu=${currency || "INR"}`;

  if (note) {
    url += `&tn=${encodeURIComponent(note)}`;
  }

  return url;
}
